import type { ActiveSuppressionRecord } from '../types';

const MS_PER_SECOND = 1_000;

/**
 * The operator-visible end: `expiresAt` carries the backend's stop buffer on top of the duration,
 * so it is used only when the record has no duration of its own (the device fallback never reaches
 * the wire).
 */
export const resolveActiveSuppressionEndMs = (suppression: ActiveSuppressionRecord): number =>
  suppression.duration != null && suppression.duration > 0
    ? Date.parse(suppression.startedAt) + suppression.duration * MS_PER_SECOND
    : Date.parse(suppression.expiresAt);
